export enum AnimationTypes {
  NONE = 'none',
  FADE_SLIDE = 'fadeSlide',
}
